import { createContext, useContext } from "react";

/**
 * Shared context for the interactive onboarding tour.
 *
 * Extracted into its own file so TourProvider (which creates the state)
 * and TourOverlay (which consumes it) don't have to import each other —
 * a circular import that breaks tree-shaking and can trip up production
 * builds when either file has side-effectful imports.
 */
export const TourContext = createContext(null);

export const useTour = () => useContext(TourContext);
